module.exports = __webpack_public_path__ + "img/icon2.d9e198c5.png";